import { defineStore } from "pinia";
import { ref } from "vue";

import { getNotificationSettings } from "../api/getNotificationSettings";
import { updateNotificationSettings } from "../api/updateNotificationSettings";

// Дефолт — всё включено. Применяется, пока настройки пользователя не загрузились
// и для пользователей без явных настроек (бэк возвращает все true).
const DEFAULTS = {
    systemNotifyRent: true,
    systemNotifyShift: true,
    systemNotifyVk: true,
    systemNotifyWidget: true,
    systemNotifyTariff: true,
    notifyBeforeEndRent: true,
};

export const useNotificationSettingsStore = defineStore(
    "NotificationSettingsStore",
    () => {
        const settings = ref({ ...DEFAULTS });
        const loaded = ref(false);

        // Снимок последнего сохранённого состояния — чтобы не слать PUT-эхо сразу
        // после загрузки и не дублировать одинаковые сохранения.
        let lastSerialized = null;

        const load = async () => {
            settings.value = await getNotificationSettings();
            lastSerialized = JSON.stringify(settings.value);
            loaded.value = true;
        };

        const save = async () => {
            const serialized = JSON.stringify(settings.value);

            if (serialized === lastSerialized) {
                return;
            }

            await updateNotificationSettings(settings.value);
            lastSerialized = serialized;
        };

        return { settings, loaded, load, save };
    }
);
